/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Injectable } from '@angular/core';
import {
  BarChartData,
  BarChartDatasetsModel,
  BarChartModel,
  BarChartOptions,
  DistGraphData,
  DistGraphOptions,
  DistributionGraphModel
} from '../models/timetracking.model';

@Injectable({
  providedIn: 'root'
})
export class TimeTrackingService {
  //distribution chart properties
  mean: number = 0;
  standardDeviation: number = 0;
  format_standardDeviation: number = 0;
  distributionGraphLabelsArray: (string | number)[] = [];
  distGraphData!: DistGraphData;
  distGraphOptions!: DistGraphOptions;

  //Bar chart properties
  barChartData!: BarChartData;
  barChartOptions!: BarChartOptions;
  constructor() {}

  // distribution graph methods >>
  calculateNormalDistribution(arr: number[]): (string | number)[] {
    //at first the array should be for all the tasks (all checkpoints)
    //If the user choose a checkpoint from the dropdown list , the arr should depend on that checkpointID

    // calculate Mean
    let total = 0;
    arr.forEach((element) => {
      total += element;
    });
    this.mean = total / arr.length;

    // calculate Standard deviation
    let temp: number;
    let tempTotal: number = 0;
    arr.forEach((element) => {
      temp = Math.pow(element - this.mean, 2);
      tempTotal += temp;
    });

    this.standardDeviation = Math.sqrt((1 / arr.length) * tempTotal);

    //Format Standard Deviation to always show 2 decimal places
    this.format_standardDeviation = this.formatDecimalNumber(this.standardDeviation);

    this.distributionGraphLabelsArray = [
      '',
      this.formatDecimalNumber(this.mean - 2 * this.format_standardDeviation),
      this.formatDecimalNumber(this.mean - this.format_standardDeviation),
      this.formatDecimalNumber(this.mean),
      this.formatDecimalNumber(this.mean + this.format_standardDeviation),
      this.formatDecimalNumber(this.mean + 2 * this.format_standardDeviation),
      ''
    ];

    return this.distributionGraphLabelsArray;
  }
  formatDecimalNumber(num: number) {
    //Format number to always show 2 decimal places
    return +(Math.round(num * 100) / 100).toFixed(2);
  }
  createDistributionGraph(arr: number[]): DistributionGraphModel {
    this.distGraphData = {
      labels: this.calculateNormalDistribution(arr),
      datasets: [
        {
          label: $localize`:@@timeTrackingDistributionDataset:Dataset`, //this label is hidden
          data: [1, 2, 4, 10, 4, 2, 1], //static, just for drowing the graph.
          fill: true,
          borderColor: '#4A7563',
          tension: 0.4
        }
      ]
    };
    this.distGraphOptions = {
      scales: {
        x: {
          display: true,
          title: {
            display: true,
            text: $localize`:@@timeTrackingHoursAxis:Hours`
          }
        },
        y: {
          display: false
        }
      },
      plugins: {
        legend: {
          display: false
        },
        tooltip: {
          enabled: false
        }
      }
    };

    return {
      distGraphData: this.distGraphData,
      distGraphOptions: this.distGraphOptions
    };
  }

  // Bar Chart methods
  createBarChart(labelsArray: string[], dataArray: BarChartDatasetsModel[]): BarChartModel {
    this.barChartData = {
      labels: labelsArray,
      datasets: dataArray
    };
    this.barChartOptions = {
      scales: {
        y: {
          display: true,
          title: {
            display: true,
            text: $localize`:@@timeTrackingHoursAxis:Hours`
          },
          ticks: {
            beginAtZero: true
          }
        },
        x: {
          display: true,
          title: {
            display: true,
            text: $localize`:@@timeTrackingCheckpointsAxis:Checkpoints`
          }
        }
      }
    };

    return {
      barChartData: this.barChartData,
      barChartOptions: this.barChartOptions
    };
  }

  median(arr: number[]) {
    const mid = Math.floor(arr.length / 2),
      nums = [...arr].sort((a, b) => a - b);
    return arr.length % 2 !== 0 ? nums[mid] : (nums[mid - 1] + nums[mid]) / 2;
  }
}
